import { useIsSSR } from "eddev/routing"
import { useEffect, useState } from "react"
import * as z from "zod"
import valueFromEmpty from "zod-empty"

function loadPref(storageKey: string, schema: z.ZodSchema<any>) {
  if (typeof localStorage !== "undefined") {
    const stored = localStorage.getItem(storageKey)
    if (stored) {
      try {
        return schema.parse(JSON.parse(stored))
      } catch (err) {}
    }
  }
  return valueFromEmpty(schema)
}

function savePref(storageKey: string, value: any) {
  localStorage.setItem(storageKey, JSON.stringify(value))
}

/**
 * This is like useState, except that it stores the value in localStorage
 *
 * A Zod schema is used for validation, so that outdated versions can be ignored!
 */
export function useSchemaPref<T extends z.ZodType>(key: string, schema: T) {
  const storageKey = `pref:${key}`
  const [value, setValue] = useState<z.infer<T>>(loadPref(storageKey, schema))
  const ssr = useIsSSR()

  return [
    (ssr ? valueFromEmpty(schema) : value) as z.infer<T>,
    (value: z.infer<T>) => {
      setValue(value)
      savePref(storageKey, value)
    },
  ] as const
}
